import React from 'react';
import './event-list.css';

const UNKNOWN_DATE_LABEL = 'Unknown date';

export const formatSharedEventDate = (dateValue) => {
  if (dateValue === null || dateValue === undefined || dateValue === '') {
    return UNKNOWN_DATE_LABEL;
  }

  const date = new Date(dateValue);
  const timestamp = date.getTime();
  if (Number.isNaN(timestamp) || timestamp <= 0) {
    return UNKNOWN_DATE_LABEL;
  }

  return date.toLocaleDateString();
};

const EventList = ({ events }) => {
  if (!events || events.length === 0) {
    return <p>No shared events found.</p>;
  }

  return (
    <div className="event-list">
      <h4>Shared Events</h4>
      <ul>
        {events.map(event => (
          <li key={event.id}>
            <span className="event-date">{formatSharedEventDate(event.date)}</span>
            <span className="event-name">{event.name}</span>
            <span className="event-attendees">{event.attendeeCount} attendees</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default EventList;
